import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { initVersionCheck, startPeriodicVersionCheck } from '@/utils/versionCheck'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 在应用启动前执行版本检查（基于JS文件名Hash检测）
initVersionCheck()

// 启动定期版本检查（每5分钟检查一次，适用于移动端）
startPeriodicVersionCheck(5 * 60 * 1000)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
